'use client';
import { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { DateView } from '@mui/x-date-pickers';
import { SxProps, Theme } from '@mui/material/styles';
interface CalendarProps {
  value: Dayjs | null;
  onChange: (newValue: Dayjs | null) => void;
  disableFuture: boolean;
  views?: DateView[];
  openTo?: DateView;
  sx?: SxProps<Theme>;
}

export function Calendar({ value, onChange, disableFuture, views, openTo, sx }: CalendarProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateCalendar
        value={value}
        disableFuture={disableFuture ? disableFuture : false}
        onChange={onChange}
        views={views}
        openTo={openTo}
        sx={{
          '& .MuiPickersYear-yearButton.Mui-selected': {
            color: '#fff !important',
            backgroundColor: 'primary.dark',
          },
          '& .MuiButtonBase-root.MuiPickersDay-root.Mui-selected': {
            backgroundColor: 'primary.dark',
          },
          '&. MuiButtonBase-root.MuiPickersDay-root': {
            fontsize: '16px',
            fontWeight: 400,
            color: '#1D1B20',
          },
          '& .MuiTypography-root.MuiDayCalendar-weekDayLabel': {
            color: '#1D1B20',
            fontsize: '16px !important',
            fontWeight: 400,
          },
          '& .mui-14iq4xa-MuiDayCalendar-root': {
            padding: '0px 18px',
          },
          '& .MuiPickersCalendarHeader-root': {
            padding: '0px 19px 0px 26px',
          },

          '.mui-1yodouj-MuiPickersMonth-monthButton.Mui-selected ': {
            color: '#fff !important',
            backgroundColor: 'primary.dark',
          },

          '.MuiPickersDay-root.Mui-selected': {
            color: '#fff !important',
            backgroundColor: 'main.dark !important',
            fontWeight: '500',
          },

          '.mui-1gl8yr6-MuiButtonBase-root-MuiPickersDay-root:not(.Mui-selected) ': {
            border: 'none !important',
            outline: 'none !important',
          },
          width: 'auto',
          ...sx,
        }}
      />
    </LocalizationProvider>
  );
}
